import { FeatureFlag } from '../FeatureFlag';

export const backtestJobsListPollingIntervalMs = new FeatureFlag<number>({
    key: 'backtest-jobs-list-polling-interval-ms',
    defaultValue: 5000,
});
